import React from 'react';
import HelpPageFooterNotice from '../components/helpPageFooterNotice';

const MessageConfigurationHelp: React.FC = () => {
  return (
    <>
      <h1>Email Configuration</h1>
      <p>
        The EMAIL CONFIGURATION page will be used to configure the traveler
        facing email notifications to include your company&apos;s logo, contact
        info, and your preferred verbiage to your travelers. Email notifications
        fall under the following three alert types.
      </p>
      <h3>Trip Alert Email</h3>
      <p>
        This includes the email notifications that a traveler will receive
        during their day of travel. The standard set of emails provided are for
        trip reminders, scheduled status updates, delays, gate changes,
        connection information, and flight cancellations.
      </p>
      The following fields are available for customization:
      <ul>
        <li>
          <strong>From Email Address:</strong> The address you enter here will
          be displayed as the &quot;From&quot; email address in the email. If
          using your own email domain, you’ll be required to update your DNS
          records for validation.{' '}
          <a href="https://helpdesk.cirium.com/hc/en-us/articles/4416462253851-How-can-Cirium-send-alerts-on-behalf-of-our-email-address-">
            How can Cirium send alerts on behalf of our email address?
          </a>
        </li>
        <li>
          <strong>From Alias:</strong> Enter your company name here.
        </li>
        <li>
          <strong>Header:</strong> This appears at the top of your email and
          should contain your company’s logo and/or contact information. To
          enter your company logo in your message you will need to paste a URL
          link to your logo between the &quot;&quot; of the image source.
          Example:
          <code>
            &lt;img src=&quot;enter company logo link here&quot;
            border=&quot;0&quot; alt=&quot;&quot;&gt;
          </code>
        </li>
        <li>
          <strong>Opening:</strong> This will appear at the top of the email
          notifi to the traveler and should include a brief message including
          the contact details should the travel require assistance.
        </li>
        <li>
          <strong>Action:</strong> The verbiage entered here will be used when a
          trip experiences a cancellation or diversion. This is intended to give
          instruction to the traveler for assistance with this issue.
        </li>
        <li>
          <strong>Action With Trip Assist:</strong> This verbiage entered here
          will be used when Trip Assist is active for a trip experiences a
          cancellation or diversion and the trip. This is intended to give
          instruction to the traveler for assistance with this issue.
        </li>
        <li>
          <strong>Action on Waiver Alerts:</strong> This email is triggered with
          a trip has an airline issued exception waiver that matches one or more
          of the flights contained in a trip. This is to provide instruction to
          the traveler should they choose to take action and apply the waiver to
          make changes to their itinerary.
        </li>
        <li>
          <strong>Closing:</strong> Appears at the bottom of the message and can
          be used to gain customer feedback or just to thank them for their
          patronage.
        </li>
      </ul>
      <h3>Opt-in Email</h3>
      <p>
        The Opt-in email notification allows travelers to sign-up for Traveler
        notifications. If they do not sign-up, they will not receive them for
        their upcoming trips.
      </p>
      <p>
        Each time a traveler itinerary is passed to Cirium with an email address
        (from an agency with opt-in functionality), Cirium determines if
        messaging preferences were set-up previously by that traveler in a
        personal Trip Alert Profile. If not, an agency-branded and edited Opt-in
        email will be sent, asking the traveler to register and create a
        personal Trip Alert Profile.
      </p>
      The following fields are available for customization:
      <ul>
        <li>
          <strong>From Email Address:</strong> The address you enter here will
          be displayed as the &quot;From&quot; email address in the email. If
          using your own email domain, you’ll be required to update your DNS
          records for validation.{' '}
          <a href="https://helpdesk.cirium.com/hc/en-us/articles/4416462253851-How-can-Cirium-send-alerts-on-behalf-of-our-email-address-">
            How can Cirium send alerts on behalf of our email address?
          </a>
        </li>
        <li>
          <strong>From Alias:</strong> Enter your company name here.
        </li>
        <li>
          <strong>Subject:</strong> This will appear in the subject line in the
          Opt-in email invitation and should provide a brief description for the
          purpose of the email, such as “Opt-In and Register for Trip Alerts”.
        </li>
        <li>
          <strong>Header:</strong> This appears at the top of your email and
          should contain your company’s logo and/or contact information. To
          enter your company logo in your message you will need to paste a URL
          link to your logo between the &quot;&quot; of the image source.
          Example:
          <code>
            &lt;img src=&quot;enter company logo link here&quot;
            border=&quot;0&quot; alt=&quot;&quot;&gt;
          </code>
        </li>
        <li>
          <strong>Opening:</strong> This is how you would like to address your
          travelers to let them know what the Opt-in invitation is for, what
          your providing, and how the customer is benefiting from traveling with
          your agency.
        </li>
        <li>
          <strong>Closing:</strong> Appears at the bottom of the message and can
          be used to gain customer feedback or just to thank them for their
          patronage.
        </li>
      </ul>
      <h3>Trip Reminder Email</h3>
      <p>
        The Trip Reminder message is an additional messaging option that can be
        added at the Account or Group level. By default, the Trip Reminder
        message is sent 24hrs prior to the departure time and provides the
        scheduled flight information, destination weather forecast, as well as
        another opportunity to register to receive flight status alerts.
      </p>
      The following fields are available for customization:
      <ul>
        <li>
          <strong>From Email Address:</strong> The address you enter here will
          be displayed as the &quot;From&quot; email address in the email. If
          using your own email domain, you’ll be required to update your DNS
          records for validation.{' '}
          <a href="https://helpdesk.cirium.com/hc/en-us/articles/4416462253851-How-can-Cirium-send-alerts-on-behalf-of-our-email-address-">
            How can Cirium send alerts on behalf of our email address?
          </a>
        </li>
        <li>
          <strong>From Alias:</strong> Enter your company name here.
        </li>
        <li>
          <strong>Header:</strong> This appears at the top of your email and
          should contain your company’s logo and/or contact information. To
          enter your company logo in your message you will need to paste a URL
          link to your logo between the &quot;&quot; of the image source.
          Example:
          <code>
            &lt;img src=&quot;enter company logo link here&quot;
            border=&quot;0&quot; alt=&quot;&quot;&gt;
          </code>{' '}
        </li>
        <li>
          <strong>Closing:</strong> Appears at the bottom of the message and e
          used used to gain customer feedback or just to thank them for their
          patronage.
        </li>
      </ul>
      <h3>Trip Group</h3>
      <p>
        This drop-down will include the default email configuration for your
        account and any Trip Groups that have custom email configurations
        applied.
      </p>
      <ul>
        <li>
          <strong>Default Configuration:</strong> Your companies
          &quot;Default&quot; settings will be used for the majority, if not all
          of your messaging for your company. These settings should be
          configured to include your company&apos;s logo, contact info, and your
          preferred verbiage to your customers.
        </li>

        <li>
          <strong>Custom Configuration:</strong> Email configurations c an be
          cust for an individual Trip Group, allowing you to either brand the
          group with their own company logo, messaging verbiage, or to include
          specific contact information. Trip Groups that have custom messaging
          activated will appear in the drop down menu. To have a group turn on
          for custom messaging, you will need to contact Cirium Help Desk and
          let us know that you would like a Trip Group to activate for custom
          messaging.
        </li>
      </ul>
      <p>
        <strong>Cancel:</strong> Used to cancel any changes that have been made
        to the email configuration.
      </p>
      <p>
        <strong>Save:</strong> Used to save any changes that have been made to
        the email configuration.
      </p>
      <HelpPageFooterNotice />
    </>
  );
};

export default MessageConfigurationHelp;
